import { IStackStyles } from "@bps/fluent-ui";

export const gridRowStyles: IStackStyles = {
  root: {
    display: "grid",
    gridTemplateColumns: "repeat(12, 1fr)",
    gap: 8
  }
};
